import { Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LOCALES } from '../../features/language/locales';
import { styles } from '../../style/style';
import { LanguageContext } from "./LanguageWrapper";

export default function LanguageSelection() {
  const context = useContext(LanguageContext);
  const options = [{ label:'English', value: LOCALES.ENGLISH_US }
    , { label: 'Français', value: LOCALES.FRENCH_CA }
  /*,{ label:'English (Canadian)', value: LOCALES.ENGLISH_CA }
  ,{ label: 'Spanish-MX', value: LOCALES.SPANISH_MX }*/];


  let selectValue;

  if (localStorage.getItem('locale') !== null || localStorage.getItem('locale') === "") {
    selectValue = localStorage.getItem('locale');
  } else {
    selectValue = context.locale
  }

  return (
    <Box className='languageDropdown' sx={styles.langBoxSx}>
      <Stack direction='row' spacing={0}>
        <Typography variant="body1" sx={styles.langSelectionLabel}><FormattedMessage id='mainnavbar.language' defaultMessage='Langauge' />:</Typography>
        <FormControl variant="standard" sx={styles.langSelectForm}>
          <Select
            sx={styles.selectLanguage}
            labelId="demo-simple-select-standard-label"
            id="languageDropDown"
            value={selectValue}
            onChange={context.selectLang}
            MenuProps={{ disableScrollLock: true }}
          >
            {options.map(option => {
              return <MenuItem id={option.label+"Option"}key={option.value} value={option.value}>{option.label}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Stack>
    </Box>

  );
}